import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { NATIONAL_DATA_ACTION_TYPE } from "./national-data.action";
import { NationalDataState } from "./national-data.model";

const initialState: NationalDataState = {};

export function nationalDataReducer(state = initialState, action: ActionWithPayload): NationalDataState {
	switch (action.type) {
		case NATIONAL_DATA_ACTION_TYPE.getBirthCitiesSuccess: {
			return updateState(state, {
				birthCities: action.payload,
			});
		}
		case NATIONAL_DATA_ACTION_TYPE.getCountryByTaxCode: {
			return updateState(state, { birthCountry: undefined });
		}
		case NATIONAL_DATA_ACTION_TYPE.getCountryByTaxCodeSuccess: {
			return updateState(state, { birthCountry: action.payload });
		}
		case NATIONAL_DATA_ACTION_TYPE.getTaxCodeByCountry: {
			return updateState(state, { birthCountry: undefined });
		}
		case NATIONAL_DATA_ACTION_TYPE.getTaxCodeByCountrySuccess: {
			return updateState(state, { birthCountry: action.payload });
		}
		default:
			return state;
	}
}
